/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, Inject } from '@angular/core';
import { CustomWindow } from '@dgx-pr-spa/shared/util';
import { ENVIRONMENT } from '@dgx-pr-spa/ui-components';

export type GtmData = { [key: string]: any };

declare let window: CustomWindow;

@Injectable()
export class AnalyticsService {
  constructor(@Inject(ENVIRONMENT) private environment: any) {}
  eventEmitter(data: GtmData) {
    // Make sure the dataLayer property exists on the window object,
    // or we will not be able to communicate with GTM.

    if (!Object.hasOwnProperty.call(window, 'dataLayer')) {
      throw new Error('`window.dataLayer` is not defined.');
    }
    window.dataLayer.push({
      ...data,
      clientName: this.environment.gaClientName || 'DG PR',
    });
  }
}
